import {
  AnnotationInfoIcon,
  CheckCircleFilledIcon,
  ChevronStrokeIcon,
  CoinsStackedIcon,
  DownloadOutlineIcon,
  EditIcon,
  FilmStripIcon,
  InfoSquareFilledIcon,
  LockOutlineIcon,
  DeleteOutlineIcon,
  TrophyOutlineIcon,
  UserPlusOutlineIcon
} from '@/components/common/icon';

type IconProps = { className?: string };

const ICONS = {
  chevronDown: (props: IconProps) => (
    <ChevronStrokeIcon {...props} direction="down" />
  ),
  chevronUp: (props: IconProps) => (
    <ChevronStrokeIcon {...props} direction="up" />
  ),
  chevronRight: ChevronStrokeIcon,
  edit: (props: IconProps) => <EditIcon {...props} compact />,
  film: (props: IconProps) => <FilmStripIcon {...props} compact />,
  annotationInfo: AnnotationInfoIcon,
  checkCircle: CheckCircleFilledIcon,
  coinsStacked: CoinsStackedIcon,
  download: DownloadOutlineIcon,
  infoSquare: InfoSquareFilledIcon,
  lock: LockOutlineIcon,
  trash: DeleteOutlineIcon,
  trophy: TrophyOutlineIcon,
  userPlus: UserPlusOutlineIcon
};
export type CreatorQuoteDesignIconName = keyof typeof ICONS;

export default function CreatorQuoteDesignIcon({
  name,
  className = 'h-4 w-4'
}: {
  name: CreatorQuoteDesignIconName;
  className?: string;
}) {
  const Icon = ICONS[name];
  return (
    <span aria-hidden className={`inline-block flex-shrink-0 ${className}`}>
      <Icon className="block h-full w-full" />
    </span>
  );
}
